jQuery.validator.addMethod("validate_email", function(value, element) {

  if (/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(value)) {
    return true;
  } else {
    return false;
  }
}, "Please enter a valid email.");
